import React from 'react';
import { Form as RffForm, FormProps } from 'react-final-form';

import styles from './Form.module.css';

const Form: <FormValues = Record<string, any>, InitialFormValues = Partial<FormValues>>(
  props: FormProps<FormValues, InitialFormValues>
) => React.ReactElement = ({ render, ...props }) => (
  <RffForm
    {...props}
    render={
      ({ submitError, ...renderProps }) => (
        <>
          { submitError && <div className={styles.formError}>{submitError}</div>}
          {render && render({ submitError, ...renderProps })}
        </>
      )
    }
  />
);

export default Form;
